"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function IoLink(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { d: "M22 0c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2H2c-1.1 0-2-.9-2-2V2C0 .9.9 0 2 0zm0 2H2v20h20V2zm-9.648 11.848l.037.434c.256-.336.608-.502 1.057-.502.385 0 .674.115.863.343.19.23.289.579.295 1.039v2.383H13.45V15.21c0-.187-.037-.324-.114-.412-.074-.088-.211-.131-.41-.131a.55.55 0 0 0-.502.266v2.61h-1.152v-3.696h1.08zm4.375 2.32l-.324.324v1.053H15.25v-5.254h1.153v2.789l.115-.152.869-1.08h1.38l-1.296 1.519 1.38 2.178h-1.317l-.807-1.377zM9.43 17.545h1.154v-3.697H9.43v3.697zm-.069-4.652c0-.164.059-.297.178-.403a.667.667 0 0 1 .461-.158c.189 0 .344.053.461.158a.514.514 0 0 1 .178.403.516.516 0 0 1-.178.404.666.666 0 0 1-.461.156.666.666 0 0 1-.461-.156.516.516 0 0 1-.178-.404zm-2.533 3.73h2.088v.922H5.63v-4.977h1.2v4.055zM13.053 5.5c.422 0 .797.101 1.127.301.33.201.588.486.77.857.185.37.277.793.279 1.272v.23c0 .484-.09.914-.27 1.287a1.975 1.975 0 0 1-.767.863c-.33.204-.71.303-1.133.303a2.18 2.18 0 0 1-1.127-.29 2.008 2.008 0 0 1-.768-.837 2.874 2.874 0 0 1-.29-1.248v-.28c0-.487.09-.917.269-1.29.179-.373.435-.66.769-.863a2.146 2.146 0 0 1 1.14-.305zm-2.871.068v4.977H8.985V5.568h1.197zm2.87.871c-.601 0-.92.451-.954 1.354l-.002.367c0 .486.08.861.242 1.123a.791.791 0 0 0 .72.395.784.784 0 0 0 .702-.387c.164-.258.248-.627.25-1.11v-.23c0-.494-.084-.869-.248-1.127a.797.797 0 0 0-.71-.385z", fill: props.color || "#000", fillRule: "nonzero" })));
}
exports.default = IoLink;
